import Vue from 'vue';
export default {
  getBrandList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/merchant/brand/queryRecommendBrand', {params});
  },
  getProductList(params) {
    return Vue.axios.post('/rx/user/api/v1.0/merchant/product/selectProductList', params);
  },
  getProductDetail(id) {
    return Vue.axios.get(`/rx/user/api/v1.0/merchant/product/getProductById/${id}`);
  }
};
